import React from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { Stack, Button, Typography } from "@mui/material";
import useShoppingCartContext from "../../context/ShoppingCart/use-shopping-cart-context";

export default function ShoppingCartFooter({ handleAddToCartClick }) {
  // ==============================================================================
  const { t } = useTranslation();
  const { calculateTotal, cart } = useShoppingCartContext();

  const cartTotal = calculateTotal();
  const isEmpty = cart.items.length === 0;

  // == Render ====================================================================
  return (
    <Stack
      width="100%"
      bottom={0}
      bgcolor="white"
      position="absolute"
      direction="column"
    >
      <Stack
        width="100%"
        padding="16px 24px"
        direction="row"
        alignItems="center"
        borderBottom="1px solid rgba(0, 0, 0, 0.12)"
        justifyContent="space-between"
      >
        <Typography variant="h5" color="secondary" fontWeight={700}>
          {t("total")}
        </Typography>
        <Typography variant="h5" color="secondary" fontWeight={700}>
          ${cartTotal.toFixed(2)} USD
        </Typography>
      </Stack>
      <Stack padding="16px 24px" gap="32px">
        <Stack
          width="100%"
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="caption" color="secondary">
            {t("shopping_cart.taxes_included")}
          </Typography>
          <Typography variant="caption" color="secondary">
            ${cartTotal.toFixed(2)} USD
          </Typography>
        </Stack>
        <Button
          variant="contained"
          onClick={handleAddToCartClick}
          color="secondary"
          size="large"
          sx={{ color: "white" }}
          disabled={isEmpty}
        >
          {t("shopping_cart.continue_purchase")}
        </Button>
      </Stack>
    </Stack>
  );
}
